<template>
  <div class="category-list-row" :class="{
      [state]: true,
      'exclusives': isExclusive
  }" @click="$emit('click')">
      <div class="category-row-info w-100">
        <div class="qrw-heading-xs v1-grey-3-color" :class="{
            'red-3-color': untranslated
        }" v-if="state != 'edit'">
            {{ title }}
        </div>
        <div class="qrw-heading-xs edit-block" v-if="state == 'edit'">
            <BaseInput :placeholder="placeholder" class="category-name-input" v-model="edit_value"/>
            <BaseButton @click="$emit('rename', edit_value)" icon="check" color="v1-grey-10" size="md" variant="secondary" class="ml-8"/>
        </div>
        <div class="qrw-label-sm" :class="{
          'v1-grey-6-color': state != 'selected',
          'green-1-color': state == 'selected'
      }" v-if="state != 'edit'">
            {{ count }} {{ $t("nouns.dishes") }}
        </div>
      </div>
      <div class="category-icon v1-grey-2-color" v-if="state == 'rearrange'">
          <BaseIcon icon="list" size="lg"/>
      </div>
      <div class="category-index" :class="{
          'v1-grey-9-color': state != 'selected',
          'green-6-color': state == 'selected',
          'yellow-5-color': state == 'edit'
      }" v-else-if="!isExclusive">
          {{ index + 1}}
      </div>
      <div class="category-icon" :class="{
          'v1-grey-9-color': state != 'selected',
          'green-6-color': state == 'selected'
      }" v-else>
          <BaseIcon icon="star-bold" size="lg"/>
      </div>

  </div>
</template>

<script>
export default {
    props: {
        title: String,
        state: {
            type: String,
            default: 'default'
        },
        isExclusive: Boolean,
        index: Number,
        count: Number,
        untranslated: {
            type: Boolean,
            default: false
        },
        placeholder: String
    },
    data() {
        return {
            edit_value: null
        }
    },
    watch: {
        title() {
            if (this.state != 'edit') {
                this.edit_value = this.title;
            }
        }
    },
    mounted() {
        this.edit_value = this.title;
    }
}
</script>

<style scoped>
.category-list-row  {
    width: 100%;
    padding: 16px;
    background: var(--v1-grey-10-color);

    display: flex;
    justify-content: space-between;
    align-self: center;
    align-content: center;

    box-sizing: border-box;

    position: relative;
    z-index: 0;

    cursor: pointer;

    max-height: 72px;
    height: 72px;
}

.category-list-row.selected {
    background: var(--green-6-color);
}

.category-list-row.exclusives {
    background: var(--black-color);
}

.category-list-row.selected.exclusives {
    background: var(--green-6-color);
}

.category-list-row.rearrange, .category-list-row.rearrange > *  {
    user-select: none;
}

.category-list-row.edit {
    background: var(--yellow-4-color);
    align-items: center;
    align-content: center;
}

.category-index {
    font-size: 68px;
    position: absolute;
    right: 8px;
    top: -4px;
    z-index: 0;
}

.category-row-info {
    position: relative;
    z-index: 1;
}

.category-icon {
    position: absolute;
    right: 8px;
}

.edit-block {
    display: flex;
}

.category-name-input {
    width: 75%;
}
</style>
